"use strict";
'use strict';

var clipboard = require('./clipboard.cjs');



exports.Context = clipboard.ClipboardContext;
exports.Control = clipboard.ClipboardControl;
exports.CopyText = clipboard.ClipboardCopyText;
exports.Indicator = clipboard.ClipboardIndicator;
exports.Input = clipboard.ClipboardInput;
exports.Label = clipboard.ClipboardLabel;
exports.PropsProvider = clipboard.ClipboardPropsProvider;
exports.Root = clipboard.ClipboardRoot;
exports.RootProvider = clipboard.ClipboardRootProvider;
exports.Trigger = clipboard.ClipboardTrigger;
exports.ValueText = clipboard.ClipboardValueText;
